import InspectionItemCollection from '@editor/collections/InspectionItem'
import { BlueprintEditorTools } from '@editor/pages/projects/blueprint-editor/definitions'
import { serializableToConnectedAreas } from '@editor/pages/projects/pcd-alignment/utils'
import { createSelector } from '@reduxjs/toolkit'

import { RootState } from './app'
import { makeSubSelector } from './utils'

// ## Custom deep selectors
export const useToolUtilSelector = makeSubSelector((root: RootState) => root.toolUtil.core)
export const useVertexSelector = makeSubSelector((root: RootState) => root.toolUtil.vertex)

/**
 * Retrieve connected areas from the store and convert to AlignedArea format.
 */
export const selectConnectedAreas = createSelector(
  [(state: RootState) => state.page.connectedAreas],
  (connectedAreas) => serializableToConnectedAreas(connectedAreas),
)

/**
 * Select the current anchor position only if the specified tool is selected.
 *
 * @param tool The tool to select the anchor position for.
 */
export const selectCurrentAnchorPositionByTool = (tool: BlueprintEditorTools) =>
  createSelector(
    [
      (state: RootState) => state.toolUtil.core.currentAnchorPosition,
      (state: RootState) => state.blueprint.editor.selectedTool,
    ],
    (currentAnchorPosition, selectedTool) => {
      if (selectedTool !== tool) return undefined
      return currentAnchorPosition
    },
  )

/**
 * Select inspection items from the store and initialize it as a Collection.
 */
export const selectInspectionItems = createSelector(
  [(state: RootState) => state.inspectionItems.items],
  (items) => new InspectionItemCollection(items),
)
